module.exports = __webpack_public_path__ + "img/shiping1.ddd177a8.svg";